"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var elevation_1 = require("../../sharedStyle/elevation");
var animation_1 = require("../../sharedStyle/animation");
var StyledDiv = styled_components_1["default"].div;
var StyledTooltip = StyledDiv(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: fixed;\n  background-color: #fff;\n  padding: 12px;\n  border-radius: 2px;\n  ", ";\n  opacity: ", ";\n  visibility: ", ";\n  transition: opacity ", " ", ";\n"], ["\n  display: inline-block;\n  position: fixed;\n  background-color: #fff;\n  padding: 12px;\n  border-radius: 2px;\n  ", ";\n  opacity: ", ";\n  visibility: ", ";\n  transition: opacity ", " ", ";\n"])), elevation_1.elevation8, function (props) { return (props.show ? 1 : 0); }, function (props) { return (props.show ? 'visible' : 'hidden'); }, animation_1.standardDuration, animation_1.standardCurveTiming);
var ChartTooltip = /** @class */ (function (_super) {
    __extends(ChartTooltip, _super);
    function ChartTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChartTooltip.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(StyledTooltip, __assign({ style: { top: this.props.top, left: this.props.left }, show: this.props.show }, { children: this.props.children })));
    };
    return ChartTooltip;
}(react_1.PureComponent));
exports["default"] = ChartTooltip;
var templateObject_1;
